import { RootState } from 'store/types';

export const cartInfoSelector = (state: RootState) => state.cartInfo;

export const cartItemCount = (state: RootState) =>
  cartInfoSelector(state).itemCount;

export const cartData = (state: RootState) => cartInfoSelector(state).cartData;
